import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { storage } from '@bfe/by-storage';
var DEFAULT_LANG_KEY = 'i18nextLng'; // This i18next default key

var defaultOpts = {
  defaultLanguage: 'en',
  cacheKey: DEFAULT_LANG_KEY,
  supportLangs: ['en', 'en-US', 'zh-CN', 'zh-TW', 'ja-JP', 'ko-KR', 'ru-RU', 'id-ID', 'es-ES', 'tr-TR', 'th-TH', 'vi-VN', 'de-DE' // 'zh-HK'
  ]
};
var regulatedSiteHosts = 'BYBIT';

if (typeof window !== 'undefined') {
  var hostname = window.location.hostname;

  regulatedSiteHosts = function () {
    if (/^[^.]+\.[^.]+\.[^.]+\.hk$/.test(hostname) || /^[^.]+\.[^.]+\.[^.]+\.[^.]+\.hk$/.test(hostname)) {
      return 'HKG';
    }

    if (/^[^.]+\.[^.]+\.ae$/.test(hostname) || /^[^.]+\.[^.]+\.[^.]+\.ae$/.test(hostname)) {
      return 'ARE';
    }

    return 'BYBIT';
  }();
}

if (regulatedSiteHosts === 'HKG') {
  defaultOpts.defaultLanguage = 'zh-HK';
  defaultOpts.supportLangs = ['en-HK', 'zh-HK'];
}

var LanguageDetector = /*#__PURE__*/function () {
  function LanguageDetector(services) {
    var detectorOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nextOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, LanguageDetector);

    this.init(services, detectorOptions, i18nextOptions);
  }

  _createClass(LanguageDetector, [{
    key: "init",
    value: function init(services, detectorOptions) {
      this.options = _objectSpread(_objectSpread({}, defaultOpts), detectorOptions);
    }
  }, {
    key: "detect",
    value: function detect() {
      var _this$options = this.options,
          cacheKey = _this$options.cacheKey,
          _this$options$support = _this$options.supportLangs,
          supportLangs = _this$options$support === void 0 ? [] : _this$options$support,
          defaultLanguage = _this$options.defaultLanguage;

      var _URL = new URL(window.location.href),
          searchParams = _URL.searchParams;

      var lang = searchParams.get('lang') || storage.get(cacheKey) || navigator.language;
      var fixedLang = supportLangs.indexOf(lang) > -1 ? lang : defaultLanguage;

      if (!['announcements', 'learn', 'blog'].some(function (host) {
        return window.location.hostname.includes(host);
      })) {
        document.querySelector('html').setAttribute('lang', fixedLang);
      }

      storage.set(cacheKey, fixedLang);
      return fixedLang;
    }
  }]);

  return LanguageDetector;
}();

LanguageDetector.type = 'languageDetector'; // Just add here to avoid no function call

LanguageDetector.prototype.cacheUserLanguage = function () {};

export default LanguageDetector;